<div class="bg-white min-h-screen">
    <!-- Hero Section -->
    <div class="bg-app-background-20 py-16 border-b border-gray-200">
        <div class="max-w-4xl mx-auto px-6">
            <h1 class="text-4xl font-fraunce text-app-primary-20 mb-4">Datenschutz</h1>
            <p class="text-app-secondary-10 text-xl">Stand: April 2025</p>
        </div>
    </div>

    <!-- Content -->
    <div class="max-w-4xl mx-auto px-6 py-16">
        <div class="grid grid-cols-1 gap-12">

            <section class="prose max-w-none text-app-secondary-10">
                <p>Wir freuen uns über Ihr Interesse an unserem Arztportal. Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Im Folgenden informieren wir Sie ausführlich über die Erhebung, Verarbeitung und Nutzung personenbezogener Daten im Rahmen unserer Website.</p>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">1. Verantwortlicher</h2>
                <div class="text-app-secondary-10 space-y-4">
                    <p>Verantwortlich für die Datenverarbeitung im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:</p>
                    <div class="bg-gray-50 p-6 rounded-lg">
                        <p class="font-medium text-app-primary-20">Aliacura e.K.</p>
                        <p>Hauptstraße 4, 91443 Scheinfeld</p>
                        <p>E-Mail: <a href="mailto:datenschutz@patriacura.de" class="text-app-primary-10 hover:underline">datenschutz&#64;patriacura.de</a></p>
                    </div>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">Gesetzlich vorgeschriebener Datenschutzbeauftragter</h2>
                <div class="text-app-secondary-10">
                    <p>Wir haben für unser Unternehmen einen Datenschutzbeauftragten bestellt:</p>
                    <p class="mt-2 font-medium">Bernhard Metzger</p>
                    <p>Schwarzenbergstr. 20, 91443 Scheinfeld</p>
                    <p>E-Mail: <a href="mailto:bernhard.metzger@patriacura.de" class="text-app-primary-10 hover:underline">bernhard.metzger&#64;patriacura.de</a></p>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">2. Allgemeines zur Datenverarbeitung</h2>
                <div class="text-app-secondary-10 space-y-6">
                    <div>
                        <h3 class="font-medium text-app-primary-20 mb-2">Speicherdauer</h3>
                        <p>Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung haben.</p>
                    </div>
                    <div>
                        <h3 class="font-medium text-app-primary-20 mb-2">Rechtsgrundlagen</h3>
                        <p>Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 DSGVO (Einwilligung, Vertragserfüllung, rechtliche Verpflichtung oder berechtigtes Interesse). Details entnehmen Sie den folgenden Abschnitten.</p>
                    </div>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">3. Hosting und Infrastruktur</h2>
                <div class="text-app-secondary-10 space-y-4">
                    <p>Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>
                    <div class="bg-gray-50 p-6 rounded-lg border-l-4 border-app-primary-10">
                        <p class="font-bold text-app-primary-20 mb-1">Hetzner Online GmbH</p>
                        <p>Industriestr. 25, 91710 Gunzenhausen</p>
                        <p class="text-sm mt-2">Die Verwendung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer zuverlässigen Darstellung).</p>
                    </div>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">4. Erfassung von Daten auf unserer Website</h2>
                <div class="text-app-secondary-10 space-y-6">
                    <div>
                        <h3 class="font-medium text-app-primary-20 mb-2">Server-Log-Dateien</h3>
                        <p>Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt (IP-Adresse, Zeitstempel, Browser-Typ etc.).</p>
                    </div>
                    <div>
                        <h3 class="font-medium text-app-primary-20 mb-2">Registrierung und Portalnutzung</h3>
                        <p>Bei der Registrierung erfassen wir Stammdaten (Name, Geburtsdatum, Adresse) sowie Identitätsnachweise (Ausweisscan). Diese Daten sind für die Durchführung ärztlicher Behandlungen zwingend erforderlich (Art. 6 Abs. 1 lit. b DSGVO).</p>
                    </div>
                    <div>
                        <h3 class="font-medium text-app-primary-20 mb-2">Telesprechstunden</h3>
                        <p>Die Durchführung der Sprechstunde liegt in der Verantwortung der Ärzte. Behandlungsrelevante Daten werden zu Ihrer Sicherheit bei einem Arztwechsel (nach Einwilligung) übertragen.</p>
                    </div>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">5. Zahlungsdienste</h2>
                <div class="text-app-secondary-10 space-y-4">
                    <p>Wir binden Zahlungsdienste von Drittunternehmen ein (PayPal, Banken). Für diese Transaktionen gelten die jeweiligen Datenschutzbestimmungen der Anbieter.</p>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="p-4 border rounded-lg">
                            <p class="font-bold mb-1">PayPal</p>
                            <p class="text-sm">PayPal (Europe) S.à.r.l. et Cie, S.C.A.</p>
                        </div>
                        <div class="p-4 border rounded-lg">
                            <p class="font-bold mb-1">Banküberweisung</p>
                            <p class="text-sm">SEPA-Verfahren über beteiligte Kreditinstitute.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">6. Ihre Rechte</h2>
                <div class="text-app-secondary-10">
                    <p class="mb-4">Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf:</p>
                    <ul class="grid grid-cols-1 sm:grid-cols-2 gap-2 list-none">
                        <li class="flex items-center gap-2"><i class="fa-solid fa-check text-app-primary-10"></i> Auskunft (Art. 15 DSGVO)</li>
                        <li class="flex items-center gap-2"><i class="fa-solid fa-check text-app-primary-10"></i> Berichtigung (Art. 16 DSGVO)</li>
                        <li class="flex items-center gap-2"><i class="fa-solid fa-check text-app-primary-10"></i> Löschung (Art. 17 DSGVO)</li>
                        <li class="flex items-center gap-2"><i class="fa-solid fa-check text-app-primary-10"></i> Einschränkung (Art. 18 DSGVO)</li>
                        <li class="flex items-center gap-2"><i class="fa-solid fa-check text-app-primary-10"></i> Datenübertragbarkeit (Art. 20 DSGVO)</li>
                        <li class="flex items-center gap-2"><i class="fa-solid fa-check text-app-primary-10"></i> Widerspruch (Art. 21 DSGVO)</li>
                    </ul>
                    <p class="mt-6 p-4 bg-app-background-20 rounded text-center">
                        Kontakt für Datenschutzanfragen: <span class="font-bold">datenschutz&#64;patriacura.de</span>
                    </p>
                </div>
            </section>
        </div>
    </div>
</div>
